import React, {FunctionComponent, useRef, useState} from "react";
import {Modal} from "antd";
import TextArea, {TextAreaRef} from "antd/lib/input/TextArea";
import {InputStatus} from "antd/lib/_util/statusUtils";
import "./index.scss";

type Props = {
  users: any[];
  isVisible: boolean;
  setModalVisibility: (isVisible: boolean) => void;
  onConfirm: (excludeReason: string) => void;
}

export const ExclusionConfirmationModal: FunctionComponent<Props> = (
  {
    users,
    isVisible,
    setModalVisibility,
    onConfirm
  }
) => {
  const [status, setStatus] = useState<InputStatus>("");
  const [excludeReason, setExcludeReason] = useState("");
  const reasonElementRef = useRef<TextAreaRef>();

  const getUserName = (user) => `${user.user.first} (${user.user.second})`;

  const onOkButtonClick = () => {
    setStatus(excludeReason ? "" : "error")
    if (excludeReason) {
      onConfirm(excludeReason)
    } else {
      // @ts-ignore
      reasonElementRef.current.focus()
    }
  };

  const onReasonChange = (event) => {
    setExcludeReason(event.target.value);
    setStatus((excludeReason || event.target.value) ? "" : "error")
  }

  return (
    <Modal
      title={"Exclusion"}
      visible={isVisible}
      confirmLoading={false}
      closable={false}
      maskClosable={false}
      width={450}
      destroyOnClose={true}
      afterClose={() => setExcludeReason("")}
      onCancel={() => setModalVisibility(false)}
      okButtonProps={{onClick: onOkButtonClick, disabled: false}}
      cancelButtonProps={{disabled: false}}
      okText={"Confirm"}
      cancelText="Cancel"
      className="start-modal exclusion-modal"
    >
      <div className="modal-content-body">
        <div className="modal-content-body-text">
          {users.map((user) => (
            <div className="user-details" key={user.key}>
              <div> User: <span className="details-highlighted">{getUserName(user)}</span></div>
              <div> Job profile: <span className="details-highlighted">{user.jobProfile}</span></div>
            </div>
          ))}
          Reason to Exclude (Required)
          <TextArea
            onChange={onReasonChange}
            maxLength={1000}
            style={{
              width: "100%", height: 70, fontSize: 14, padding: 10, resize: "none"
            }}
            // @ts-ignore
            ref={reasonElementRef}
            status={status}
            required
          />
        </div>
      </div>
    </Modal>
  );
};
